import PoLookup from '@/store/modules/poLookup/constants';
import PurchaseOrderService from '@/services/purchaseOrderService';

const purchaseOrderService = new PurchaseOrderService();

export default {
  [PoLookup.actionTypes.getSearchResults](vuex, pagination) {
    return purchaseOrderService.getPurchaseOrderFindResults(pagination.searchTextPONumberOrSku,
      pagination.pageNumber,
      pagination.pageSize)
      .then(result => Promise.resolve(result))
      .catch(() => Promise.resolve(false));
  },

  async [PoLookup.actionTypes.loadSearchPage]({ dispatch, commit }, payload) {
    commit(PoLookup.mutationTypes.executeSearch, payload.searchText);
    let result = null;
    try {
      result = await dispatch(PoLookup.actionTypes.getSearchResults, {
        searchTextPONumberOrSku: payload.searchText,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize,
      });
    } finally {
      commit(PoLookup.mutationTypes.searchFinished, {
        searchText: this.purchaseOrderNumber,
        searchPage: result,
      });
    }
  },
};
